import { OAuthProviderType } from '~apis/auth/maybeSignInWithOAuth';
import { OAUTH_AUTH_DOMAIN } from '~constants/env';

export const getOauthRedirectUrl = (provider: OAuthProviderType) => {
  const env = process.env.APP_ENV;

  // finance.cloud 도메인에서는 OAUTH_AUTH_DOMAIN으로 OAuth 처리
  if (typeof window !== 'undefined' && window.location.hostname.endsWith('.finance.cloud')) {
    return `${OAUTH_AUTH_DOMAIN}/oauth/${provider.toLowerCase()}/callback`;
  }

  // 기존 로직: clobe.ai 도메인은 현재 도메인 사용
  const domain =
    typeof window !== 'undefined'
      ? window.location.origin
      : env === 'local'
        ? 'https://app.dev.clobe.ai'
        : 'https://app.clobe.ai';
  return `${domain}/oauth/${provider.toLowerCase()}/callback`;
};

export const generateRandomState = () => {
  // finance.cloud 도메인이면 state에 원래 도메인 정보 포함 (리다이렉트용)
  if (typeof window !== 'undefined' && window.location.hostname.endsWith('.finance.cloud')) {
    const originalDomain = window.location.origin;
    const randomPart = Math.random().toString(36).substring(2) + Date.now().toString(36);
    // 원래 도메인을 base64 인코딩하여 state에 포함
    const encodedDomain = btoa(originalDomain);
    return `${randomPart}_${encodedDomain}`;
  }

  return Math.random().toString(36).substring(2) + Date.now().toString(36);
};
